<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <div
        v-for="data in dataList"
        :key="data.siteId"
        class="chart-item"
      >
        <div class="chart-item-header">
          <span>{{data.siteName}}</span>
        </div>

        <div class="chart-item-body">
          <vocs-category-chart
            ref="data-renders"
            :site-name="data.siteName"
            :data="data.data"
            :top="data.top"
          />
        </div>
      </div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import LayoutContent from '../../../../../components/Layout/Content'
import BaseSiteData from '../../../../BaseSiteData'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import VocsCategoryChart from './VocsCategoryChart'
import SiteQuery from '../../../../../components/Data/Query/SiteQuery'

export default {
  name: 'DataManagementVOCsCategoryStatistical',
  routeInfo: {
    label: 'VOCs分类统计',
    icon: 'fa fa-users'
  },
  extends: BaseSiteData,
  components: {SiteQuery, VocsCategoryChart, DataWrapper, LayoutContent},
  data: () => ({
    query: {
      unit: 'ppb',
      isMultipleIntegral: true,
      isFuse: false,
      isGetInvalidData: true
    }
  }),
  computed: {
    deviceCategories: () => [
      [process.env.ALL_VOCS_DEVICE_CATEGORY],
      1
    ]
  },
  methods: {
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false
    //   this.afterSetSiteIds()
    // },
    formatData () {
      let {filterSiteMap, factorGroupMap, factorMap} = this
      this.dataList = Object.freeze(this.tmpList.reduce((list, {siteId, data, top}) => {
        let site = filterSiteMap[siteId]

        if (site) {
          list.push({
            siteId,
            siteName: site.name,
            data: data.map(({groupId, value, isHaveIntegral}) => ({
              groupId,
              groupName: factorGroupMap[groupId].name,
              isHaveIntegral: isHaveIntegral,
              value
            })),
            top: top.reduce((list, {factor_id: factorId, value, isHaveIntegral}) => {
              let factor = factorMap[factorId]

              if (factor) {
                list.push({
                  factorId,
                  factorName: factor.name,
                  isHaveIntegral: isHaveIntegral || 0,
                  value: Number(value.toFixed(3))
                })
              }

              return list
            }, [])
          })
        }

        return list
      }, []))
    },
    getData () {
      this.changeLoadStatus(true)

      this.$api.Data.getVOCsCategoriesStatistic(this.currentQuery).then(dataList => {
        this.tmpList = dataList
        this.formatData()
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-item-header {
  display: grid;
  grid-template-columns: auto max-content;
  align-items: center;
  width: 100%;
  line-height: 1.8em;
  padding: 0 10px;
  background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
  background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
  color: #ffffff;
  font-weight: 600;
}

.chart-item-body {
  height: 400px;
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/04VOCs-Category-Statistical/index.vue